/** @jsx jsx */
import { Fragment, h } from 'preact';

// Searchspring
import { getContext } from '@searchspring/snap-toolbox';

// Packages
import { jsx, css } from '@emotion/react';
import classnames from 'classnames';

// Local
import { Prices } from '../../Prices/Prices';

// CSS
import '../../Result/result.css';

export function PersonalizedProductCard({ cardProps: { parentProps, styling, parentSubProps } }) {
	const { result, className, layout, controller, index } = parentProps;

	const context = getContext(['region']);
	const core = result?.mappings?.core;

	const lazy = index >= 3 ? "lazy" : "eager";

	const plpMedia = result?.attributes?.mfield_custom_plp_tile_media;
	const plpDescription = result?.attributes?.mfield_custom_plp_tile_description;
	const plpPricingType = result?.attributes?.mfield_custom_plp_tile_pricing;
	const isPlpVideo = plpMedia && /\.(mp4|webm|mov|ogg)(\?|$)/i.test(plpMedia);

	const optimizedImageUrl = core?.imageUrl.replace('600x600', '300x220');
	const priceRange = result?.attributes?.ss_price_range ? result?.attributes?.ss_price_range : null;
	const onSale = result?.attributes?.ss_on_sale ? "on--sale" : "not-on--sale";

	let productUrl = core.url;
	if (window.Shopify.locale == 'fr') {
		productUrl = `/fr${productUrl}`;
	}

	return (
		<article {...styling} className={classnames('ss__result', 'ss__result--personalized', `ss__result--${layout}`, className)}>
			<a
				href={productUrl}
				onMouseDown={(e) => {
					controller?.track?.product?.click(e, result);
				}}
				className={`ss__result-link ${onSale}`}
				aria-label={core.name}
			>
				<div className="product-card-top-wrapper">
					<div className="ss__result__image-wrapper">
						<div {...styling} className={classnames('ss__image', 'ss__result__image')}>
							{plpMedia ? (
								isPlpVideo ? (
									<video
										class="product__img product__img--main"
										src={plpMedia}
										autoplay
										muted
										loop
										playsinline
										width="260"
										height="180"
									/>
								) : (
									<img
										id={`ProductImage-${result.id}`}
										alt={core.name}
										class="product__img product__img--main"
										src={plpMedia}
										width="260"
										height="180"
										loading={lazy}
									/>
								)
							) : (
								<img
									id={`ProductImage-${result.id}`}
									alt={core.name}
									class="product__img product__img--main"
									src={optimizedImageUrl}
									width="260"
									height="180"
									loading={lazy}
								/>
							)}
						</div>
					</div>
					<div className="ss__result__details">
						<div className="ss__result__details__top_row body-large">
							<div className="ss__result__details__pricing body-medium">
								{context.region == 'us' && <Prices priceRange={priceRange} core={core} subProps={parentSubProps} pricingType={plpPricingType} />}
								{context.region == 'ca' && <Prices priceRange={priceRange} core={core} subProps={parentSubProps} pricingType={plpPricingType} />}
								{context.region == 'uk' && window.Resources.marketHandle == 'uk' && (
									<Prices priceRange={priceRange} core={core} subProps={parentSubProps} pricingType={plpPricingType} />
								)}
							</div>
						</div>
						<div className="ss__result__details__title body-medium">{core.name}</div>
						{plpDescription && (
							<p className="ss__result__plp-description">{plpDescription}</p>
						)}
					</div>
				</div>
			</a>
		</article>
	);
}
